export default __webpack_public_path__ + "navigation-guides-turn-by-turn-ui-maneuver-instructions-1200-3ce5ec0732f139c481e6c9b381078c26.webp";